import { render } from "./AboutMenu.vue?vue&type=template&id=7c90d4fa&scoped=true&ts=true"
import script from "./AboutMenu.vue?vue&type=script&lang=ts"
export * from "./AboutMenu.vue?vue&type=script&lang=ts"

import "./AboutMenu.vue?vue&type=style&index=0&id=7c90d4fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c90d4fa"]])

export default __exports__